import { getCurrencies, getCurrencyRates, getCurrencyRate } from '../utils/apiService';

export const LIST_CURRENCIES = 'currency/LIST_CURRENCIES';
export const LIST_CURRENCIES_PENDING = 'currency/LIST_CURRENCIES_PENDING';
export const LIST_CURRENCIES_REJECTED = 'currency/LIST_CURRENCIES_REJECTED';
export const LIST_CURRENCIES_FULFILLED = 'currency/LIST_CURRENCIES_FULFILLED';

export const LIST_CURRENCY_RATES = 'currency/LIST_CURRENCY_RATES';
export const LIST_CURRENCY_RATES_PENDING = 'currency/LIST_CURRENCY_RATES_PENDING';
export const LIST_CURRENCY_RATES_REJECTED = 'currency/LIST_CURRENCY_RATES_REJECTED';
export const LIST_CURRENCY_RATES_FULFILLED = 'currency/LIST_CURRENCY_RATES_FULFILLED';

export const FETCH_CURRENCY_RATE = 'currency/FETCH_CURRENCY_RATE';
export const FETCH_CURRENCY_RATE_PENDING = 'currency/FETCH_CURRENCY_RATE_PENDING';
export const FETCH_CURRENCY_RATE_REJECTED = 'currency/FETCH_CURRENCY_RATE_REJECTED';
export const FETCH_CURRENCY_RATE_FULFILLED = 'currency/FETCH_CURRENCY_RATE_FULFILLED';

export const listCurrencies = () => {
    const payload = getCurrencies();
    return {
        type: LIST_CURRENCIES,
        payload
    }
}

export const listCurrencyRates = () => {
    const payload = getCurrencyRates();
    return {
        type: LIST_CURRENCY_RATES,
        payload
    }
}

export const fetchCurrencyRate = (currency) => {
    const payload = getCurrencyRate(currency);
    return {
        type: FETCH_CURRENCY_RATE,
        payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/currencies.js